import styles from './NotificationsPanel.module.scss';

/**
 * Notifications content rendered inside CharacterHomeHeader's notifications dropdown.
 * No notification source is wired up yet (there's no account-facing
 * notification feed on the server) - this is the placeholder shell for it.
 */
export function NotificationsPanel(): JSX.Element {
    return (
        <div className={styles.panel}>
            <p className={styles.empty}>No notifications yet.</p>
        </div>
    );
}
